import $ from "jquery";

export default function artistSearch() {
  const showHeader = (show) => {
    header.css("visibility", (!!show ? 'visible' : 'hidden'));
  }

  const updateCount = (count) => {
    header.find('span.count').text(count);
  }

  const header = $('.artistlist__results__header');
  const searchInput = $('.artist-artwork-search__search input');
  const artists = $(".artistlist__results__list article");

  showHeader(false);

  searchInput.on("change paste keyup", function() {
    const searchValue = $(this).val().toLowerCase();

    if (!!searchValue) {
      const result = artists.filter(function() {
        return $(this).data("name").toLowerCase().indexOf(searchValue) > -1
      });

      artists.hide();
      result.show();
      showHeader(true);
      updateCount(result.length);
    } else {
      artists.show();
      showHeader(false);
    }
  });
}
